const themes = {
  baseColors: {
    'primary':                  { light: '#3b495b', dark: '#7e8ea5' },
    'primary-accent':           { light: '#6428bd', dark: '#6428bd' },
    'primary-rh':               { light: '#5454a4', dark: '#5454a4' },
    'secondary':                { light: '#28253f', dark: '#28253f' },
    'accent':                   { light: '#08d7d7', dark: '#08d7d7' },
    'background':               { light: '#f4f4f4', dark: '#1f1f1f' },
    'foreground':               { light: '#504F4F', dark: '#e0e0e0' },
    'foreground-accent':        { light: '#f4f4f4', dark: '#e0e0e0' },
  },

  components: {
    'muted':                    { light: '#ffffff', dark: '#303030' },
    'muted-immutable':          { light: '#EAEAEA', dark: '#EAEAEA' },
    'muted-accent':             { light: '#6b6b6b', dark: '#6b6b6b' },
    'muted-foreground':         { light: '#d9d9d9', dark: '#6b6b6b' },
    'inactive':                 { light: '#BDBDBD', dark: '#6b6b6b' },
    'footer-background':        { light: '#f4f4f4', dark: '#111719' },

    'list-background':          { light: '#f4f4f4', dark: '#404040' },
    'base-hover':               { light: '#6b6b6b', dark: '#4a4a4a' },
    'autocomplete-chip':        { light: '#e0e0e0', dark: '#555555' },
  },

  other: {
    'scroll-background':        { light: '#e7f0f9', dark: '#504F4F' },
    'info':                     { light: '#0d7abd', dark: '#0d7abd' },
    'success':                  { light: '#43aa8b', dark: '#43aa8b' },
    'error':                    { light: '#e63946', dark: '#e63946' },
    'warning':                  { light: '#FFC107', dark: '#FFC107' },
    'warning-background':       { light: '#FDF5E6', dark: '#FDF5E6' },
    'shadow':                   { light: '#6B6B6B', dark: '#000000' },
  },

  inputs: {
    'border':                   { light: '#e0e0e0', dark: '#6B6B6B' },
    'border-accent':            { light: '#1900FF', dark: '#1900FF' },
    'border-accent-background': { light: '#E3F2FD', dark: '#E3F2FD' },
  },
};

const flatten = (mode) => Object.values(themes)
  .reduce((merged, group) => ({
    ...merged,
    ...Object.entries(group).reduce((grouped, [theme, value]) => ({
      ...grouped,
      [theme]: value[mode],
    }), {}),
  }), {});

export const lightTheme = flatten('light');
export const darkTheme = flatten('dark');
export const groupedThemes = Object.keys(themes).reduce((acc, key) => ({
  ...acc,
  [key]: Object.keys(themes[key]),
}), {});

export default themes;
